import type { ReferencedTweetSummaryBasicInfoAllOfTwoTweetType } from './referencedTweetSummaryBasicInfoAllOfTwoTweetType';

export type ReferencedTweetSummaryBasicInfoAllOfTwo = {
  content?: string;
  /** 트윗 유형 */
  tweetType?: ReferencedTweetSummaryBasicInfoAllOfTwoTweetType;
};
